import { createContext, Dispatch, SetStateAction } from 'react'
import { TEmailAPIContext } from './types'
import { EOperatorTypes } from 'cakemail-ui-components-v2'

export const EmailAPIContext = createContext<TEmailAPIContext>({
    timeRange: "1d",
    trendRange: 3,
    emailTags: undefined,
    search: "",
    rightHandMenu: undefined,
    setRightHandMenu: () => { },
    setEmailReportTagFilters: () => { },
    providerFilter: [],
    tagsFilter: [],
    filterOperator: EOperatorTypes.or,
    refreshKey: 0
})